import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Col, Divider, Form, Radio, Row, Typography } from 'antd';

import { PageProps } from '@/types/PageProps';
import { SaveButton } from '@/components/_common';

import { UpdateMatrixSettingsRequest } from '@/types/Register';
import {
  useMatrix,
  useMatrixUpdate,
} from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { useEffect } from 'react';
import { useWindowSize } from '@/hooks';

const { Title } = Typography;

interface PasswordSettingsFormValues {
  passwordExpirationDays: number;
}

function PasswordSettingsPage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<PasswordSettingsFormValues>();

  const { data } = useMatrix();
  const mutationEdit = useMatrixUpdate();
  const { width } = useWindowSize();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        passwordExpirationDays: data.matrixSettings.passwordExpirationDays,
      });
    }
  }, [data]);

  const handleEditSettings = async () => {
    const values = await form.validateFields();

    if (data) {
      const obj: UpdateMatrixSettingsRequest = {
        id: data.id,
        matrixSettings: {
          ...values,
          id: data.matrixSettings.id,
        },
      };
      mutationEdit.mutateAsync(obj);
    }
  };

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />
      <div className="page">
        <div className="page-header">
          <Title level={4}>{intl.formatMessage({ id: route.name })}</Title>
          {!(width < 992) && (
            <SaveButton
              onClick={handleEditSettings}
              loading={mutationEdit.isLoading}
            >
              {intl.formatMessage({
                id: 'commons.form.button.save',
              })}
            </SaveButton>
          )}
        </div>

        <Divider />

        <Form form={form} style={{ marginTop: width < 576 ? '0px' : '24px' }}>
          <Row gutter={[16, 12]}>
            <Col sm={24}>
              <Title level={width < 576 ? 5 : 4}>
                Período de expiração de senhas
              </Title>

              <Form.Item name="passwordExpirationDays">
                <Radio.Group
                  optionType="button"
                  buttonStyle="solid"
                  size="large"
                >
                  <Radio value={0}>Não expira</Radio>
                  <Radio value={90}>3 meses</Radio>
                  <Radio value={180}>6 meses</Radio>
                  <Radio value={365}>12 meses</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {width < 992 && (
          <SaveButton
            block
            onClick={handleEditSettings}
            loading={mutationEdit.isLoading}
          >
            {intl.formatMessage({
              id: 'commons.form.button.save',
            })}
          </SaveButton>
        )}
      </div>
    </>
  );
}

export default PasswordSettingsPage;
